import React, { Component } from 'react';
import {
    Nav,
    NavItem,
    NavLink,
    NavbarToggler,
    NavbarBrand,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from 'reactstrap';
import Avatar from 'react-avatar';

import Registry from "../../Utils/Registry";
import Helpers from "../../Utils/Helpers";

import { SignOut } from "@TaankYou/auth";


class Header extends Component {

    constructor(props) {
        super(props);

        this.api = Registry.registered("api");

        this.toggle = this.toggle.bind(this);
        this.logoutClicked = this.logoutClicked.bind(this);
        this.sidebarToggle = this.sidebarToggle.bind(this);
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        this.onNavItemClicked = this.onNavItemClicked.bind(this);

        this.state = {
            dropdownOpen: false,
            user: null,
            logo: null,
            open: true,
            mobileOpen: true
        };
    }

    componentDidMount(){
        let user = Registry.observe(this, "user", new_user => {
            this.setState({user:new_user});
        });

        let logo_url = Registry.observe(this, "business-logo", logo_url => {
            this.loadLogo(logo_url);
        });

        Registry.observe(this, "business-logo-data", data => {
            this.setState({logo: data});
        });

        this.setState({
            user: user
        }, () => { 
            if(logo_url)
                this.loadLogo(logo_url);
        });
    }

    loadLogo = url => {
        url = url.replace(this.api.url, "");
        this.api.get(url + "?return_as=text", { response_type: "text" })
            .then(data => {
                this.setState({logo: data});
            })
            .catch(_ => {});
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    sidebarToggle(e) {
        this.setState({open: !this.state.open});
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    mobileSidebarToggle(e=null) {
        if (e)
            e.preventDefault();
        this.setState({mobileOpen: !this.state.mobileOpen});
        document.body.classList.toggle('sidebar-mobile-show');
    }

    logoutClicked(){
        const { protocol, host } = window.location;
        SignOut(`${protocol}//${host}`);
    }

    onNavItemClicked(){
        this.mobileSidebarToggle();
    }

    render() {
        return (
            <header className="app-header navbar">
                <NavbarToggler className="d-lg-none no-outline" onClick={this.mobileSidebarToggle}>{!this.state.mobileOpen ? <div>&#9587;</div> : <div>&#9776;</div>}</NavbarToggler>
                <NavbarBrand href="/home" className="navbrand-border no-display-logo">
                    {
                        this.state.logo ?
                            <img src={this.state.logo} style={{height:"59px"}} />
                            :
                            this.state.user ?
                                this.state.user.business_name
                                :
                                ""
                    }
                </NavbarBrand>
                <NavbarToggler className="d-md-down-none no-outline" onClick={this.sidebarToggle}>{this.state.open ? <div>&#9587;</div> : <div>&#9776;</div>}</NavbarToggler>
                <Nav className="d-xs-down-none" navbar>
                    <NavItem className="px-3">
                        <NavLink href={this.props.current_path}>{this.props.title}</NavLink>
                    </NavItem>
                </Nav>
                <Nav className="ml-auto pad-r-20" navbar>
                    <NavItem>
                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <DropdownToggle className="nav-link dropdown-toggle">
                                {this.state.user ?
                                    <Avatar
                                        className="marg-r-10 marg-l-10"
                                        name={this.state.user.first_name + " " + this.state.user.last_name }
                                        size={50}
                                        round={true}
                                    />
                                    :
                                    ""
                                }
                                <span className="d-md-down-none marg-l-10">{this.state.user ? this.state.user.first_name + " " + this.state.user.last_name : ""}</span>
                            </DropdownToggle>
                            <DropdownMenu right className={this.state.dropdownOpen ? 'show' : ''}>
                                <DropdownItem onClick={() => { Helpers.goTo("/mon-compte") }}><i className="icon-setting" /> Mon compte</DropdownItem>
                                <DropdownItem onClick={this.logoutClicked}><i className="icon-log-out" /> Se deconnecter</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </NavItem>
                </Nav>
            </header>
        )
    }
}

Header.defaultProps = {
    current_path: "/home",
    title: "Home"
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js